import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { SharedService } from "../shared-service.service";
import { CampaignService } from "src/app/_services/campaign.service";
import {
  CampaignStatus,
  EmailPreference,
  ICampaign,
  ICampaignStage,
} from "src/app/model/campaign";
import { EmailIntegrationService } from "src/app/_services/email-integration.service";
import { EmailsettingsService } from "src/app/_services/emailsettings.service";
import { LocalStorageService } from "src/app/_services/local-storage.service";
import { Router } from "@angular/router";
import { GlobalService } from "src/app/_services/global.service";
import moment from "moment";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { map, startWith } from "rxjs/operators";
import { EmailCampaignAssistantComponent, EmailCampaignAssistantData } from "src/app/openai/email-campaign-assistant/email-campaign-assistant.component";
import { EmailCampaignService, CampaignStagePrompt } from "../email-campaign.service";
import Quill from 'quill';
import { Observable } from "rxjs";
import { Editor } from "primeng/editor";
import { DomSanitizer } from "@angular/platform-browser";
import { CustomInputComponent } from "src/app/custom-input/custom-input.component";
import { Attachment } from 'src/app/attachment-list/attachment-list.component';
const notOnlyWhitespace = (control: UntypedFormControl) => {
  if (control.value?.includes("<p>")) {
    let temp = control.value;
    temp = temp.split(" ").join("");
    temp = temp.split("<p>").join("");
    temp = temp.split("</p>").join("");
    if (temp.length === 0) return { notOnlyWhitespace: true };
  } else if (control.value && control.value.trim().length === 0) {
    return { notOnlyWhitespace: true };
  }
  return null;
};

@Component({
    selector: "app-edit-panel",
    templateUrl: "./edit-panel.component.html",
    styleUrls: ["./edit-panel.component.scss"],
    standalone: false
})
export class EditPanelComponent implements OnInit {
  qlLinkclicked: boolean = false;
  stageFormGroup: UntypedFormGroup = new UntypedFormGroup({
    stepName: new UntypedFormControl(null, [Validators.required, notOnlyWhitespace]),
    emailTemplate: new UntypedFormControl(null),
    to: new UntypedFormControl(null, [Validators.required]),
    from: new UntypedFormControl(null, [Validators.required]),
    subject: new UntypedFormControl(null, [Validators.required, notOnlyWhitespace]),
    body: new UntypedFormControl(null, [Validators.required, notOnlyWhitespace]), //FIXME: add candidate name on candidate's place
    campaignId: new UntypedFormControl(null),
    regularDays: new UntypedFormControl(1),
    keepThread: new UntypedFormControl(true),
    schedule: new UntypedFormGroup({
      startTime: new UntypedFormControl(null, [
        (control: UntypedFormControl) => {
          if (!this.stageFormGroup) {
            return null;
          }
          return this.performDateValidation(
            moment().format("YYYY-MM-DD"),
            control.value,
            this.stageFormGroup.get("schedule")?.value.endTime
          );
        },
      ]),
      endTime: new UntypedFormControl(null, [
        (control: UntypedFormControl) => {
          if (!this.stageFormGroup) {
            return null;
          }
          return this.performDateValidation(
            moment().format("YYYY-MM-DD"),
            this.stageFormGroup.get("schedule")?.value.startTime,
            control.value
          );
        },
      ]),
      timezone: new UntypedFormControl(null, [Validators.required]),
    }),
    after_minutes: new UntypedFormControl(moment.duration(1, "d").asMinutes(), [
      Validators.required,
      Validators.min(1),
      Validators.max(30),
    ]),
    placeholder: new UntypedFormControl(null),
    isUnsubscribed: new UntypedFormControl(true)
  });

  @Input() campaign_details: any = {};
  // Dropdown options
  emailTemplates: string[] = ["Template 1", "Template 2", "Template 3"];
  toOptions: string[] = [
    "Personal Email Only",
    "Professional Email Only",
    "First Look For Personal Then Professional",
    "First Look For Professional Then Personal",
  ];
  displayBanner: boolean = true;
  integratedemailsarray: any[] = [];
  templates: string[];
  timezones: string[];
  @Input() availableStages: any;
  customtempList: [];
  InputtoEdit: any;
  sel: Selection;
  range: Range;
  placeid: boolean;
  placeholderlist = GlobalService.placeholderlist;
  dropDownValue: any;
  modalData: { templateName } = { templateName: "" };
  bodyEditor: any;
  modalRef: NgbModalRef;
  @ViewChild("createTemplateModal") createTemplateModal: TemplateRef<NgbModalRef>;

  @ViewChild("testMailConfirmation") testMailConfirmation: TemplateRef<HTMLDivElement>;
  errorMessage: string;
  successMessage: string;
  activeStage: number = 0;
  afterDays: number = 1;
  selectedEmail: string = "";
  @Input() stage: ICampaignStage;
  @Input() stages: ICampaignStage[] = [];
  @Output() isEditMode: EventEmitter<{}> = new EventEmitter<{
    stageId: null;
    editMode: false;
  }>();
  isEditing: boolean = false;
  @Output() updatedStage: EventEmitter<ICampaignStage> =
    new EventEmitter<ICampaignStage>();
  @Input() isInEditMode: { stageId; editMode };
  @Output() deleteStep: EventEmitter<number> = new EventEmitter<number>();
  @Input() prevStageId: number;
  /** Viewers who are not the campaign creator see the saved step (subject, body, schedule) but cannot edit it or send a test from the creator's mailbox. */
  @Input() readOnly = false;
  @Output() updatedCampaign: EventEmitter<ICampaign> =
    new EventEmitter<ICampaign>();
  saveAsTemplate: boolean = false;
  @ViewChild("subject") subject!: CustomInputComponent;

  composeType: 'AI' | 'MANUAL' = 'AI';

  showAIAssist: boolean = true;

  aiPromptData: EmailCampaignAssistantData;
  /**Text of unsubscribe written in mail body */
  UnsubscribeTextEmailBody: string = `<p> <a href='{{unsubscriptionUrl}}'>Click here to Unsubscribe </a> </p>`;

  private _isSendingTestEmail: boolean = false;
  public testEmailSent: boolean = false;

  get isSendingTestEmail(): boolean {
    return this._isSendingTestEmail;
  }

  value = '';
  /**
   * Whether to keep threading in email subject
   */
  get keepThreading(): boolean {
    return !!this.stage?.after_id && !!this.prevStageId
  }


  //modules: any;
  modules: any
quill: any;
@ViewChild(Editor) editor!: Editor;
timeZonesList:any;
timezonePreview:string="";


filteredOptions:any;

  /** Index of current stage */
  stageIndex: number = 0;
  /**
   * Handles the addition of attachments to the email campaign stage. Validates file type, size, and total number of attachments before adding them to the current list of attachments.
   */
  attachments = {
    new: [] as Attachment[],
    existing: [] as Attachment[],
    deleted: [] as Attachment[],
    current: [] as Attachment[]
  };

  /** Maximum allowed size for attachments in bytes */
  MAX_ATTACHMENT_SIZE = 5 * 1024 * 1024;
  /** Allowed attachment types */
  ATTACHMENT_TYPES = ['doc', 'docx', 'pdf'];
  /** Indicates whether an attachment upload is currently in progress */
  uploadAttachmentInProgress: boolean = false;

  /** Counter for generating temporary IDs for attachments */
  private tempIdCounter = 1;


testEmailFormGroup: UntypedFormGroup = new UntypedFormGroup({
  testEmail: new UntypedFormControl(null, [Validators.required, Validators.email])
});
  constructor(
    private fb: UntypedFormBuilder,
    private sharedService: SharedService,
    private campaignService: CampaignService,
    private emailintegrationservice: EmailIntegrationService,
    private emailsettings: EmailsettingsService,
    private _localstorageservice: LocalStorageService,
    private router: Router,
    private modalService: NgbModal,
    private readonly emailCampaignService: EmailCampaignService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {

    // this.createForms();
  }
  setInstance(args) {
    this.bodyEditor = args.editor;
    this.quill = args.editor;
  }

  get isDisable(){
    return (this.campaign_details?.status !== 3);
  }

  ngOnInit() {

    this.fetchIntegration();
    this.getEmailTemplate();
    this.timeZonesList = this.getSortedTimeZonesByOffset();
    const timezoneControl = this.stageFormGroup.get('schedule')?.get('timezone');
    if (timezoneControl) {
      timezoneControl.setValidators([
        Validators.required,
        (control: AbstractControl) => {
          if (!control.value) return null;
          const isValid = this.timeZonesList?.some((tz: any) => tz.timeZone === control.value);
          return isValid ? null : { invalidTimezone: true };
        }
      ]);
      timezoneControl.updateValueAndValidity();
    }
    this.stageFormGroup.get('keepThread')?.setValue(true);
    this.stageFormGroup.get('keepThread')?.valueChanges.subscribe(value => {
      if (value) {
        if (this.stage?.after_id && this.prevStageId) {
          const lastStage = this.stages.find(s => s.campaign_stage_id === this.prevStageId);
          if (lastStage && lastStage.subject) {
            this.stageFormGroup.get('subject')?.setValue(lastStage.subject.startsWith('Re: ') ? lastStage.subject : `Re: ${lastStage.subject}`);
          }
        }
      }
    });
    if(this.campaign_details['timezone']) {
      this.timezonePreview = this.timeZonesList.filter(tz=>tz.timeZone == this.campaign_details['timezone'])[0]?.offsetLabel;
      this.timezonePreview = this.campaign_details['timezone'] + " (" + this.timezonePreview + ")";
   }
     this.toggleFormState();

  const Size = Quill.import('attributors/style/size') as any;

  Size.whitelist = [
    '12px',
    '14px',
    '16px',
    '18px',
    '24px',
    '32px'
  ];

  Quill.register(Size, true);
   const Font = Quill.import('formats/font') as any;

    Font.whitelist = [
      'poppins',
      'sans-serif',
      'monospace',
      'arial'
    ];

    Quill.register(Font, true);

      // Undo / Redo icons
    const icons = Quill.import('ui/icons');

//   icons.undo = `
//   <svg viewBox="0 0 18 18">
//     <path d="M7 4L2 9l5 5" />
//     <path d="M2 9h7a5 5 0 110 10" />
//   </svg>
// `;

// icons.redo = `
//   <svg viewBox="0 0 18 18">
//     <path d="M11 4l5 5-5 5" />
//     <path d="M16 9H9a5 5 0 100 10" />
//   </svg>
// `;


      /* ---------- Quill modules ---------- */
    this.modules = {
      history: {
        delay: 1000,
        maxStack: 100,
        userOnly: true
      },
      toolbar: {
            container: '#editor-toolbar',   // 🔥 THIS FIXES THE WARNING

     handlers: {
      undo: () => {
        this.quill.history.undo();
      },
      redo: () => {
        this.quill.history.redo();
      }
    }
      }
    };
    const icons2 = Quill.import('ui/icons');

(icons as any).indent = {
  '-1': `
    <svg viewBox="0 0 18 18">
      <path d="M3 3h12v2H3z"></path>
      <path d="M3 7h10v2H3z"></path>
      <path d="M3 11h12v2H3z"></path>
      <path d="M3 15h10v2H3z"></path>
      <path d="M8 6l-3 3 3 3z"></path>
    </svg>
  `,
  '+1': `
    <svg viewBox="0 0 18 18">
      <path d="M3 3h12v2H3z"></path>
      <path d="M5 7h10v2H5z"></path>
      <path d="M3 11h12v2H3z"></path>
      <path d="M5 15h10v2H5z"></path>
      <path d="M10 6l3 3-3 3z"></path>
    </svg>
  `
};
}

toggleFormState() {
   const shouldDisable = this.campaign_details.status != 3;
  const controls = ['stepName', 'startTime', 'endTime', 'after_minutes', 'timezone', 'regularDays']; // your controls

  controls.forEach(controlName => {
    const control = this.stageFormGroup.get(controlName);
    shouldDisable ? control?.disable() : control?.enable();
  });
  if (shouldDisable) {
    this.stageFormGroup.get('schedule')?.disable();
  } else {
    this.stageFormGroup.get('schedule')?.enable();
  }
  if(this.keepThreading) {
    this.stageFormGroup.get('subject')?.disable();
  } else{
    this.stageFormGroup.get('subject')?.enable();
  }

  if((this.stage?.after_id && this.prevStageId) || (this.campaign_details.status!=3)) {
    this.stageFormGroup.get('to')?.disable();
    this.stageFormGroup.get('from')?.disable();
  } else {
    this.stageFormGroup.get('to')?.enable();
    this.stageFormGroup.get('from')?.enable();
  }

  if(!this.placeid) {
    this.stageFormGroup.get('placeholder')?.disable();
  } else {
    this.stageFormGroup.get('placeholder')?.enable();
  }
}

searchTimezone(e){
  const value = e.target.value;
  this.filteredOptions = this.timeZonesList.filter(x=>x.timeZone.toLowerCase().startsWith(value.toLowerCase()));
  // Mark dirty so the invalidTimezone validator error shows while the user is typing
  this.stageFormGroup.get('schedule')?.get('timezone')?.markAsDirty();
}
  ngOnChanges(changes: SimpleChanges) {
    this.stageIndex = this.stages.findIndex(s => s.campaign_stage_id === this.stage?.campaign_stage_id);
     this.timezones = (Intl as any).supportedValuesOf('timeZone');
    this.timeZonesList = this.getSortedTimeZonesByOffset();
    if (changes.stage) {
      const unsubscribeCheckboxFormControl = this.stageFormGroup.get('isUnsubscribed');
      const stage = changes.stage.currentValue;
      this.populatePromptData();
      if (stage && stage?.stage_name && stage?.stage_name.length) {
        this.displayBanner = false;
        this.stageFormGroup.patchValue({
          stepName: this.stage.stage_name,
          emailTemplate: null,
          to: this.campaign_details["email_pref"],
          from:
            this.campaign_details &&
            this.campaign_details["useremailintegrationid"]
              ? this.campaign_details["useremailintegrationid"]
              : null,
          subject: this.stage["subject"] || this.stages[0]?.subject,
          body: this.stage["body"],
          after_minutes: moment.duration(stage.after_minutes, "m").asDays(),
          regularDays: this.campaign_details["regular_days"] != null ? this.campaign_details["regular_days"] : stage.regular_days,
          keepThread: true,
          schedule: {
            startTime:
              this.campaign_details.schedule &&
              this.campaign_details.schedule.length &&
              !this.campaign_details.schedule.includes("null")
                ? this.campaign_details.schedule.split("-")[0]
                : "10:00",
            endTime:
              this.campaign_details.schedule &&
              this.campaign_details.schedule.length &&
              !this.campaign_details.schedule.includes("null")
                ? this.campaign_details.schedule.split("-")[1]
                : "17:00",
            timezone: this.campaign_details["timezone"],

          },
          isUnsubscribed: stage['isUnsubscribed']
        });
       // this.isDisable && unsubscribeCheckboxFormControl.disable({ onlySelf: true });

        if (!stage.after_id) {
          this.stageFormGroup.patchValue({
            // from:this.integratedemailsarray[this.campaign_details['useremailintegrationid']]['emailid'],
            campaignId: this.campaign_details["campaign_id"],
            to: this.campaign_details["email_pref"],
            schedule: {
              startTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[0]
                  : "10:00",
              endTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[1]
                  : "17:00",
              timezone: this.campaign_details["timezone"],
            },
            regularDays: this.campaign_details["regular_days"] != null ? this.campaign_details["regular_days"] : stage.regular_days,
          });
          this.stageFormGroup.get("after_minutes").clearValidators();
          this.stageFormGroup.get("after_minutes").updateValueAndValidity();
        }
        if (stage?.after_id) {

          this.displayBanner = false;
          this.afterDays = moment.duration(stage.after_minutes, "m").asDays();
          this.stageFormGroup.patchValue({
            subject: stage.subject,
            after_minutes: moment
              .duration(stage.after_minutes ? stage.after_minutes : 1440, "m")
              .days(),
            schedule: {
              startTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[0]
                  : "10:00",
              endTime:
                this.campaign_details.schedule &&
                this.campaign_details.schedule.length &&
                !this.campaign_details.schedule.includes("null")
                  ? this.campaign_details.schedule.split("-")[1]
                  : "17:00",
              timezone: this.campaign_details["timezone"],
            },
            to: this.campaign_details["email_pref"],
            regularDays: this.campaign_details["regular_days"] != null ? this.campaign_details["regular_days"] : stage.regular_days,
          });
          //set Validator for after_minutes after_minutes min value should be 1, max 30
          this.stageFormGroup
            .get("after_minutes")
            .setValidators([Validators.required, Validators.min(1), Validators.max(30)]);
          this.stageFormGroup.get("after_minutes").updateValueAndValidity();
        }
        if (this.stage){
          if (this.stage.body) {
            this.composeManually();
          } else {
            this.composeAI();
          }
        }

        // populate attachments data
        this.loadAttachments(this.stage.attachments ? [...this.stage.attachments] : [])
      } // process from data
      this.resetForm();
    }
    if (changes.campaign_details) {
      const currentDetails = changes.campaign_details.currentValue;
      this.stageFormGroup.patchValue({
        to: currentDetails["email_pref"],
        schedule: {
          startTime:
            currentDetails.schedule &&
            currentDetails.schedule.length &&
            !currentDetails.schedule.includes("null")
              ? currentDetails.schedule.split("-")[0]
              : "10:00",
          endTime:
            currentDetails.schedule &&
            currentDetails.schedule.length &&
            !currentDetails.schedule.includes("null")
              ? currentDetails.schedule.split("-")[1]
              : "17:00",
          timezone: currentDetails["timezone"],
          keepThread: true,
          regularDays: currentDetails["regular_days"] != null ? currentDetails["regular_days"] : 0
        },
      });
      this.toggleFormState();
    }
     if(this.campaign_details['timezone']) {
      this.timezonePreview = this.timeZonesList.filter(tz=>tz.timeZone == this.campaign_details['timezone'])[0]?.offsetLabel;
      this.timezonePreview = this.campaign_details['timezone'] + " (" + this.timezonePreview + ")";
   }
   if(changes.placeid) {
    this.toggleFormState();
   }
   this.cdr.detectChanges();
  }

  populatePromptData() {
    if (this.stage && this.stage.campaign_stage_id) {
      this.emailCampaignService
        .getCampaignStagePrompt(this.campaign_details.campaign_id, this.stage.campaign_stage_id)
        .subscribe((res) => {
          if (res.status === "success") {
            const prompt = res.data[0];
            if (!prompt) {
              if (!this.aiPromptData) {
                this.aiPromptData = {} as EmailCampaignAssistantData;
              };
              this.aiPromptData.id = null;
              this.aiPromptData.prompt_id = null;
              this.aiPromptData.response = null;
              return;
            }
            const promptData: EmailCampaignAssistantData = {} as EmailCampaignAssistantData;
            promptData.prompt_id = prompt.prompt_id;
            promptData.tone = prompt.tone;
            promptData.id = prompt.campaign_stage_prompt_id;
            promptData.promptType = prompt.prompt_input === 'JD' ? 'JD' : 'Role';
            if (prompt.prompt_input === 'JD') {
              promptData.jd = prompt.prompt_value;
            } else {
              promptData.role = prompt.prompt_value;
            }
            this.aiPromptData = promptData;
          }
        });
    }
  }

  onCancel() {
    if (!this.stage.after_id && !this.stage.campaign_stage_id) {
      this.displayBanner = true;
      this.isEditMode.emit({ stageId: null, editMode: false });
      this.deleteStep.emit(-1);
    } else if (this.stage.campaign_stage_id) {
      this.setEditMode();
    } else {
      this.deleteStep.emit(-1);
    }
    this.stageFormGroup.patchValue({
      //fill every key by null
      stepName: this.stage.stage_name,
      // emailTemplate: null,
      to: this.campaign_details.email_pref,
      subject: this.stage.subject,
      body: this.stage.body,
      after_minutes: this.stage.after_minutes,
      campaignId: this.campaign_details.campaign_id,
      regularDays: this.campaign_details.regular_days != null ? this.campaign_details.regular_days : this.stage.regular_days,
      keepThread: true,
      schedule: {
        startTime:
          this.campaign_details.schedule &&
          this.campaign_details.schedule.length &&
          !this.campaign_details.schedule.includes("null")
            ? this.campaign_details.schedule.split("-")[0]
            : "10:00",
        endTime:
          this.campaign_details.schedule &&
          this.campaign_details.schedule.length &&
          !this.campaign_details.schedule.includes("null")
            ? this.campaign_details.schedule.split("-")[1]
            : "17:00",
        timezone:
          this.campaign_details &&
          this.campaign_details.length &&
          this.campaign_details.timezone
            ? this.campaign_details["timezone"]
            : "Asia/Calcutta",
      },
      placeholder: null,
      from: this.campaign_details.useremailintegrationid,
    });
    // this.stageFormGroup.setErrors(null);
    // this.stageFormGroup.markAsUntouched()
    this.resetForm();
    // this.router.navigate(['email-campaign/target-listing/'+ this.campaign_details['campaign_id']])

    this.resetAttachmentState();
  }
  updateEmailStepName(value: string) {
    this.sharedService.updateEmailStepName(value);
  }
  onSaveForm1() {
    this.stageFormGroup.markAllAsTouched();
    if (!this.stageFormGroup.invalid) {
      if (this.stage && this.stage.campaign_stage_id) {
        this.updateCampaignStage(this.campaign_details["campaign_id"]);
      } else {
        this.createEmailCampaignStage();
      }
      this.updateCampaign(this.campaign_details["status"]);

      //TODO: implement save template
      if (this.saveAsTemplate) {
        this.modalRef = this.modalService.open(this.createTemplateModal, {
          size: "xs" as "lg",
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
    // this.isEditMode2 = true;
  }
  getEmailPreferenceValue(option: string): EmailPreference | null {
    switch (option) {
      case "Personal Email Only":
        return EmailPreference.Personal;
      case "Professional Email Only":
        return EmailPreference.Professional;
      case "First Look For Personal Then Professional":
        return EmailPreference.PersonalProfessional;
      case "First Look For Professional Then Personal":
        return EmailPreference.ProfessionalPersonal;
      default:
        return null;
    }
  }

  createEmailCampaignStage() {
    const formValue = this.stageFormGroup.getRawValue();
    let payloadArray = [];
    payloadArray = [
      {
        stage_name: formValue.stepName,
        campaign_id: this.campaign_details["campaign_id"],
        subject: this.sanitizeEditorContent(formValue.subject),
        body: this.sanitizeEditorContent(formValue.body) + `${(formValue.isUnsubscribed) ? this.UnsubscribeTextEmailBody : ''}` + '<img src="{{tracker}}">',
        allow_unsubscription: formValue.isUnsubscribed,
        created_by: formValue.created_by,
        is_active: true,
        created_on: formValue.created_on,
        updated_on: formValue.updated_on,
        after_minutes: moment
          .duration(formValue.after_minutes, "d")
          .asMinutes(),
        after_id: this.prevStageId,
      },
    ];

    this.campaignService
      .createStage(this.campaign_details["campaign_id"], payloadArray)
      .subscribe(
        (response: any) => {
          if (response.status == "success") {
            this.successMessage = "Stage Created Successfully";
            setTimeout(() => (this.successMessage = ""), 3000);
            this.updateStageObject(response.data[response.data.length-1]);
            if (response.data[response.data.length-1].campaign_stage_id) {
              this.bulkUploadFileOnServer(response.data[response.data.length-1].campaign_stage_id);
              // aiPromptData is only populated when the stage was composed via the AI Assist modal
              if (this.aiPromptData && (this.aiPromptData.jd || this.aiPromptData.role)) {
                const updateOrCreateData: Partial<CampaignStagePrompt> = {
                  prompt_id: this.aiPromptData.prompt_id as number,
                  prompt_input: this.aiPromptData.promptType === 'JD' ? 'JD' : 'Role',
                  prompt_value: this.aiPromptData.promptType === 'JD' ? this.aiPromptData.jd : this.aiPromptData.role,
                  tone: this.aiPromptData.tone
                };
                this.emailCampaignService.createCampaignStagePrompt(this.campaign_details.campaign_id, response.data[response.data.length-1].campaign_stage_id, [updateOrCreateData]).subscribe(() => {});
              }
            }
            // this.setEditMode();
          }
        },
        (error) => {
          this.errorMessage = "Error creating stage";
          setTimeout(() => (this.errorMessage = ""), 3000);
          console.error("Error creating stage:", error);
        }
      );
    // this.updateCampaign();
  }
  updateCampaignStage(id) {
    const formValue = this.stageFormGroup.getRawValue();
    let payloadArray = [];
    payloadArray = [
      {
        stage_name: formValue.stepName,
        campaign_id: this.campaign_details["campaign_id"],
        subject: this.sanitizeEditorContent(formValue.subject),
        body: this.sanitizeEditorContent(formValue.body) + `${(formValue.isUnsubscribed) ? this.UnsubscribeTextEmailBody : ''}` + '<img src="{{tracker}}">',
        allow_unsubscription: formValue.isUnsubscribed,
        created_by: formValue.created_by,
        is_active: true,
        created_on: formValue.created_on,
        updated_on: formValue.updated_on,
        after_minutes: moment
          .duration(formValue.after_minutes, "d")
          .asMinutes(),
        after_id: this.prevStageId,
      },
    ];
    this.campaignService
      .updateStage(id, this.stage.campaign_stage_id, payloadArray[0])
      .subscribe(
        (res: any) => {
          if (res.status == "success")
            this.successMessage = "Stage updated Successfully";
          setTimeout(() => (this.successMessage = ""), 3000);
          // this.updateStageObject(res.data);
          this.bulkUploadFileOnServer(this.stage.campaign_stage_id);

        },
        (error) => {
          this.errorMessage = "Error while  updating stage";
          setTimeout(() => (this.errorMessage = ""), 3000);
          console.error("Error updating stage:", error);
        }
      );
  }
  updateCampaign(status) {
    // getRawValue() is required here (not .value) because toggleFormState()
    // disables the 'schedule', 'to', 'from' and 'regularDays' controls when
    // campaign status != 3, and disabled controls are omitted from .value.
    const formValue = this.stageFormGroup.getRawValue();
    const schedule =
      formValue?.schedule?.startTime &&
      !formValue.schedule.startTime.includes("null") &&
      formValue.schedule.startTime !== null &&
      formValue.schedule.endTime &&
      !formValue.schedule.endTime.includes("null") &&
      formValue.schedule.startTime != null
        ? formValue.schedule.startTime +
          "-" +
          formValue.schedule.endTime
        : "10:00-17:00";
    const payloadObject = {
      campaign_id: this.campaign_details["campaign_id"],
      status: status === 1 ? CampaignStatus.Active : CampaignStatus.Draft,
      timezone: formValue.schedule.timezone,
      schedule: schedule,
      updatedon: new Date().toISOString(),
      email_pref: formValue.to,
      keep_thread: true,
      regular_days: formValue.regularDays == "1" ? 1 : 0,
      useremailintegrationid: formValue.from,
    };
    this.campaignService.updateCampaign(payloadObject).subscribe(
      (res: any) => {
        this.successMessage = "Stage updated Successfully";
        setTimeout(() => (this.successMessage = ""), 3000);
        this.isEditMode.emit({
          stageId: this.stage.campaign_stage_id,
          editMode: this.uploadAttachmentInProgress ? true : false,
        });
        this.updateCampaignObject({
          timezone: res.data.timezone,
          email_pref: res.data.email_pref,
          schedule: res.data.schedule,
          keep_thread: !!res.data.keep_thread,
          useremailintegrationid: res.data.useremailintegrationid,
          regular_days: res.data.regular_days
        });
      },
      (error) => {
        this.errorMessage = "Error updating stage";
        setTimeout(() => (this.errorMessage = ""), 3000);
        console.error("Error updating stage:", error);
      }
    );
  }
  fetchIntegration() {
    this.emailintegrationservice
      .fetchintegratedemails()
      .pipe(
        map((data: any) => {
          if (data && data.status == "success") {
            if (
              data.integratedemailsarray &&
              data.integratedemailsarray.length
            ) {
              data.integratedemailsarray = data.integratedemailsarray.map((x) =>
                Object.assign(x, {
                  useremailintegrationid: parseInt(atob(x.userintegrationid)),
                })
              );
            }
          }
          return data;
        })
      )
      .subscribe((res: any) => {
        if (res.status == "success") {
          if (res.integratedemailsarray && res.integratedemailsarray.length) {
            this.integratedemailsarray = this.integratedemailsarray;
            this.integratedemailsarray = res.integratedemailsarray;
            if (
              this.campaign_details &&
              !this.campaign_details["useremailintegrationid"]
            ) {
              this.stageFormGroup.patchValue({
                from: this.integratedemailsarray[0]["useremailintegrationid"],
              });
              this.testEmailFormGroup.patchValue({
                testEmail: this.integratedemailsarray[0]["emailid"],
              });
            }
            else {
              this.stageFormGroup.patchValue({
                from: this.campaign_details["useremailintegrationid"],
              });
              const selectedIntegration = this.integratedemailsarray.find(
                (integration) =>
                  integration.useremailintegrationid ===
                  this.campaign_details["useremailintegrationid"]
              );
              if (selectedIntegration) {
                this.testEmailFormGroup.patchValue({
                  testEmail: selectedIntegration.emailid,
                });
              }
            }
          }
        } else {
          //console.log("error Fetching emails");
        }
      });
  }
  getEmailTemplate() {
    this.emailsettings
      .getallEmailTemplate(this._localstorageservice.getItem("usernumber"))
      .subscribe((res: any) => {
        if (res.status == "success") {
          this.customtempList = res.message;
        } else {
        }
      });
  }

  selectedTemplateOption(event: any) {
    this.emailsettings
      .getEmailDetails(
        event.value,
        this._localstorageservice.getItem("usernumber")
      )
      .subscribe((res: any) => {
        if (res.status == "success") {
          this.stageFormGroup.patchValue({
            body: res.message[0].template,
            ...(!this.keepThreading ? { subject: res.message[0].subject } : {})
          });
        } else {
          //console.log("Something went Wrong")
        }
      });
      this.showAIAssist = false;
  }
  getCursorPosition(type) {
    this.InputtoEdit = type;
    this.sel = window.getSelection();
    if (this.sel.getRangeAt && this.sel.rangeCount) {
      this.range = this.sel.getRangeAt(0);

      this.placeid = true;
      this.toggleFormState();
    }
  }

  //Placeholder
  selectplaceholder(event: any, type: string) {
    if(type == 'placeholder'){
      this.qlLinkclicked = false
    }
    if(event.target?.className =='ql-image' || this.qlLinkclicked) return;
    this.dropDownValue = event.value;
    if (this.range) {
      if (this.InputtoEdit == "body") {
        if (this.bodyEditor) {
          this.bodyEditor.focus();
          if (this.bodyEditor.hasFocus()) {
            const range = this.bodyEditor.getSelection();
            if (range && range.length === 0) {
              const insertText = "{{" + this.dropDownValue + "}}";
              this.bodyEditor.insertText(range.index, insertText);
              const index = this.bodyEditor.getSelection().index;
              setTimeout(() => {
                this.bodyEditor.focus();
                this.dropDownValue = undefined;
                // this.placeid = false;
                this.stageFormGroup.patchValue({
                  body: this.bodyEditor.root.innerHTML,
                });
                this.bodyEditor.setSelection(index, 0);
              }, 0);
            }
          }
        }
      } else if (this.InputtoEdit == "subject") {
        var startPos = this.subject.nativeInput.selectionStart;
        this.subject.nativeInput.focus();
        this.subject.nativeInput.value =
          this.subject.nativeInput.value.substr(
            0,
            this.subject.nativeInput.selectionStart
          ) +
          "{{" +
          this.dropDownValue +
          "}}" +
          this.subject.nativeInput.value.substr(
            this.subject.nativeInput.selectionStart,
            this.subject.nativeInput.value.length
          );
        this.subject.nativeInput.selectionStart = startPos;
        this.subject.nativeInput.setSelectionRange(
          startPos + this.dropDownValue.length + 4,
          startPos + this.dropDownValue.length + 4
        );
        this.stageFormGroup.patchValue({
          subject: this.subject.nativeInput.value,
        });
      }
    }
    this.stageFormGroup.patchValue({
      placeholder: undefined,
    });
    this.dropDownValue = undefined;
    this.placeid = false;
  }
  setEndOfContenteditable(contentEditableElement) {
    var range, selection;
    if (document.createRange) {
      //Firefox, Chrome, Opera, Safari, IE 9+
      range = document.createRange(); //Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
      range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection(); //get the selection object (allows you to change selection)
      selection.removeAllRanges(); //remove any selections already made
      selection.addRange(range); //make the range you have just created the visible selection
    }
  }
  createTemplate() {
    if (this.modalData.templateName && !this.modalData.templateName.length) {
      return;
    }
    if (
      this.saveAsTemplate &&
      this.modalData.templateName &&
      this.modalData.templateName.length
    ) {
      let data = {
        template: {
          userid: this._localstorageservice.getItem("usernumber"),
          action: this.modalData.templateName,
          actionname: this.modalData.templateName,
          template: this.stageFormGroup.value.body,
          subject: this.stageFormGroup.value.subject,
          description: "desc",
          type: "custom",
          createdby: this._localstorageservice.getItem("usernumber"),
          updatedby: this._localstorageservice.getItem("usernumber"),
        },
        activitylog: [
          {
            action: "'create'",
            tablename: "'emailtemplates'",
            newvalue: "'new'",
            type: "'custom'",
            usertype: "'create'",
            createdby:
              "'" + this._localstorageservice.getItem("usernumber") + "'",
            userid: "'" + this._localstorageservice.getItem("usernumber") + "'",
          },
        ],
      };
      this.emailsettings.createCustomEmail(data).subscribe((res) => {
        if (res["status"] == "success") {
          this.closeModal();
          this.successMessage = "Template Created Successfully";
          this.modalData.templateName = "";
          setTimeout(() => (this.successMessage = ""), 3000);
        } else {
          this.errorMessage = "Error while creating template";
          this.modalData.templateName = "";
          setTimeout(() => (this.errorMessage = ""), 3000);
        }
      });
    }
  }
  closeModal() {
    this.saveAsTemplate = false;
    this.modalData.templateName = "";
    this.modalRef.dismiss();
  }
  /**
   * Calculates difference in minutes between two times
   * @param time1
   * @param time2
   * @returns
   */
  differenceInMinutes(time1: string, time2: string): number {
    const [hours1, minutes1] = time1.split(":");
    const [hours2, minutes2] = time2.split(":");
    const hoursDiff = Number(hours2) - Number(hours1);
    const minutesDiff = Number(minutes2) - Number(minutes1);
    const minDiff = hoursDiff * 60 + minutesDiff;
    return minDiff;
  }

  performDateValidation(startDate: string, startTime: string, endTime: string) {
    if (startDate && startTime && endTime) {
      this.stageFormGroup.get("schedule").get("startTime")?.setErrors(null);
      this.stageFormGroup.get("schedule").get("endTime").setErrors(null);
      const minDiff = this.differenceInMinutes(startTime, endTime);
      if (minDiff < 0) {
        return {
          invalid: true,
          message: "Start time should be smaller than end time.",
        };
      }

      return null;
    }
    return null;
  }

  // isEditMode(formIndex: number): boolean {
  // Assuming you have an array of edit modes corresponding to each form
  // return this.sharedService.getEditMode(formIndex);
  // }
  getFromValue(integrationid) {
    // a teammate does not own the creator's mailbox, so it is not in their own integration list
    return this.integratedemailsarray.find(
      (x) => x.useremailintegrationid == integrationid
    )?.emailid || this.campaign_details?.mailbox_email;
  }
  isStageActive(stageId: number) {
    return stageId === this.activeStage;
  }
  setEditMode() {
    if (this.readOnly) return;
    // this.isEditing = !this.isEditing;
        this.showAIAssist = false;

    this.isEditMode.emit({
      stageId: this.stage.campaign_stage_id,
      editMode: !this.isInEditMode.editMode,
    });
  }
  updateStageObject(stageObj) {
    this.updatedStage.emit({
      campaign_stage_id: stageObj.campaign_stage_id,
      campaign_id: stageObj.campaign_id,
      stage_name: stageObj.stage_name,
      subject: stageObj.subject,
      body: stageObj.body,
      created_on: stageObj.created_on,
      after_id: stageObj.after_id,
      updated_on: stageObj.updated_on,
      after_minutes: stageObj.after_minutes,
      regular_days: stageObj.regular_days,
      created_by: this.stage.created_by,
      is_active: this.stage.is_active,
      isUnsubscribed: stageObj.allow_unsubscription,
      attachments: stageObj.attachments
    });
  }
  get hasStages() {
    return this.stages && this.stages.length;
  }

  updateCampaignObject(campaignObj) {
    this.updatedCampaign.emit({
      ...this.campaign_details,
      schedule: campaignObj.schedule,
      timezone: campaignObj.timezone,
      email_pref: campaignObj.email_pref,
      keep_thread: campaignObj.keep_thread,
      useremailintegrationid: campaignObj.useremailintegrationid,
      regular_days: campaignObj.regular_days,
    });
  }
  get IsChecked() {
    return this.saveAsTemplate == true;
  }
  toggleSaveAsTemplate(event) {
    this.saveAsTemplate = event.target.value;
    return this.saveAsTemplate;
  }

  getSchedule(schedule) {
    if (
      schedule != null ||
      schedule != undefined ||
      (schedule && !schedule.includes("null"))
    ) {
      return schedule;
    } else return "10:00-17:00";
  }
  resetForm() {
    // Mark all controls as untouched
    Object.keys(this.stageFormGroup.controls).forEach((controlName) => {
      const control = this.stageFormGroup.get(controlName);
      control.markAsUntouched();
    });
  }

  renderPills(data: string, type: string) {
    if (data && data.length) {
      const temp =
        '<span class="rendered-string">' +
        data
      .replace(/<em(\s+[^>]*)?>/gi, '<i$1>')
      .replace(/<\/em>/g, '</i>')
          .replace(/\{\{/g, '<span  class="email-campaign-pill">')
          .replace(/\}\}/g, "</span>")
            +
        "</span>" + `${(type === 'body') && (this.stageFormGroup.controls.isUnsubscribed.value) ? this.UnsubscribeTextEmailBody : ''}`;
      return this.sanitizer.bypassSecurityTrustHtml(temp);
    }
  }



  composeManually() {
    this.showAIAssist = false;
    this.composeType = 'MANUAL';
    if (this.bodyEditor) {
      this.bodyEditor.root.dataset.placeholder = "Hello candidate.firstname this is regarding........";
      this.bodyEditor.focus();
    }
  }

  composeAI() {
    this.showAIAssist = true;
    this.composeType = 'AI';
    if (this.bodyEditor) {
      this.bodyEditor.root.dataset.placeholder = "";
    }
  }

  showAIAssistModal() {
    const modalRef = this.modalService.open(EmailCampaignAssistantComponent, { size: 'md', centered: true });
    const instance: EmailCampaignAssistantComponent = modalRef.componentInstance;
    instance.isModal = true;
    if (this.aiPromptData) {
      instance.data = this.aiPromptData;
    }
    // populate ladder with the previous stage content
    instance.ladder = this.stages.filter(s => s.campaign_stage_id !== this.stage.campaign_stage_id && s.campaign_stage_id && s.campaign_stage_id < Math.max(this.stage.campaign_stage_id || 0, 0)).map(s => s.body);
    modalRef.result.then((data: EmailCampaignAssistantData) => {
      if (data) {
        const updateOrCreateData: Partial<CampaignStagePrompt> = {
          prompt_id: data.prompt_id as number,
          prompt_input: data.promptType === 'JD' ? 'JD' : 'Role',
          prompt_value: data.promptType === 'JD' ? data.jd : data.role,
          tone: data.tone
        };
        // update the data in server
        if (this.stage.campaign_stage_id) {
          if (data.id) {
            this.emailCampaignService.updateCampaignStagePrompt(this.campaign_details.campaign_id, this.stage.campaign_stage_id, this.aiPromptData.id, { ...updateOrCreateData, campaign_stage_prompt_id: data.id }).subscribe(() => {});
          } else {
            this.emailCampaignService.createCampaignStagePrompt(this.campaign_details.campaign_id, this.stage.campaign_stage_id, [updateOrCreateData]).subscribe(() => {});
          }
        }
        if (data.response && typeof data.response === 'object' && data.response.subject && data.response.body) {
          this.composeType = 'AI';
          const d = {
            body: data.response.body,
          }
          if (!this.keepThreading) {
            d['subject'] = data.response.subject;
          }
          this.stageFormGroup.patchValue(d);
        }
        delete data.response;
        this.aiPromptData = data;
        this.showAIAssist = false;
      }
    }).catch(() => {});
  }


  public openTestEmailConfirmationModal() {
    this.modalRef = this.modalService.open(this.testMailConfirmation, {
      size: "md",
      centered: true,
    });
  }

  /**
   * Sends a test email using the provided email settings.
   */
  public sendTestEmail(useremailintegrationid?: any): void {
    if (this.isSendingTestEmail) return;
    this._isSendingTestEmail = true;
    this.testEmailSent = false;
    this.emailsettings.sendTestEmail({
      recipient: [this.testEmailFormGroup.value.testEmail],
      useremailintegrationid: useremailintegrationid || this.campaign_details.useremailintegrationid,
      subject: "[TEST] " + this.sanitizeEditorContent(this.stage.subject.replace(/'/g, "''")),
      body: this.sanitizeEditorContent(this.stage.body.replace(/'/g, "''")),
      replacements: {
        candidate: {
          firstname: "Test",
          lastname: "Candidate",
          currentjobtitle: "Test Job Title",
          currentcompany: "Test Company",
          currentlocation: "Test Location",
        },
        user: {
          firstname: "Test",
          lastname: "User",
          email: "test@example.com",
        }
      },
      campaign_stage_id: this.stage.campaign_stage_id,
    }).subscribe(() => {
      this._isSendingTestEmail = false;
      this.testEmailSent = true;
      setTimeout(() => {
        this.testEmailSent = false;
      }, 3000);
    });
  }

sanitizeEditorContent(html: string): string {
  return html
    // Quill/contenteditable serialize whitespace adjacent to an inserted merge
    // tag as &nbsp; entities, which breaks Handlebars parsing server-side.
    .replace(/\{\{([^}]*)\}\}/g, (match, inner) => `{{${inner.replace(/&nbsp;/gi, ' ').trim()}}}`)
    // blank line (Enter with nothing typed) -> spacer div with fixed height
    .replace(/<p>(?:\s|<br\s*\/?>)*<\/p>/g, '<div style="line-height:16px; height:16px; font-size:1px;">&nbsp;</div>')
    // regular paragraphs -> plain div, no extra spacing
    .replace(/<p>/g, '<div>')
    .replace(/<\/p>/g, '</div>')
    .replace(/ql-font-monospace/g, 'ql-font-monospace" style="font-family: monospace;')
    .replace(/ql-font-serif/g, 'ql-font-serif" style="font-family: serif;')
    .replace(/ql-font-sans/g, 'ql-font-sans" style="font-family: Arial, Helvetica, sans-serif;')
}

  insertLink(event) {
    this.qlLinkclicked = true;
  }

  displayTimezone = (value: string): string => {
  if (!value) return '';

  const tz = this.timeZonesList.find(t => t.timeZone === value);
  return tz ? `${tz.timeZone} (${tz.offsetLabel})` : value;
};

  selectOption(event) {
    const timezone = this.timeZonesList.filter(tz => tz.timeZone === event.option.value)[0];
    this.stageFormGroup.patchValue({
      schedule: {
        ...this.stageFormGroup.getRawValue().schedule,
        timezone: event.option.value

      }
    });
  }

getSortedTimeZonesByOffset() {
  const timeZones = this.timezones;
  const now = new Date();

  const result = timeZones.map(tz => {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });

    const parts = formatter.formatToParts(now);
    const v: any = {};
    parts.forEach(p => (v[p.type] = p.value));

    const localUTC = Date.UTC(
      v.year,
      v.month - 1,
      v.day,
      v.hour,
      v.minute,
      v.second
    );

    const offsetMinutes = Math.round((localUTC - now.getTime()) / 60000);

    const sign = offsetMinutes >= 0 ? "+" : "-";
    const abs = Math.abs(offsetMinutes);
    const hours = String(Math.floor(abs / 60)).padStart(2, "0");
    const minutes = String(abs % 60).padStart(2, "0");

    return {
      timeZone: tz,
      offsetMinutes,
      offsetLabel: `UTC${sign}${hours}:${minutes}`
    };
  });

  // 🔹 Sort by offset first, then alphabetically
  return result.sort((a, b) =>
    a.offsetMinutes !== b.offsetMinutes
      ? a.offsetMinutes - b.offsetMinutes
      : a.timeZone.localeCompare(b.timeZone)
  );
}

showdefaultTimezone() {
   this.filteredOptions = this.timeZonesList.filter(x=>x.timeZone.toLowerCase().startsWith(this.stageFormGroup.get('schedule').get('timezone').value.toLowerCase()));
}


  /**
   * Loads attachments from the API and initializes the attachment lists.
   * @param apiAttachments The list of attachments from the API.
   */
  loadAttachments(apiAttachments: any[] = []): void {

    this.attachments.existing = apiAttachments.map(file => ({
      id: file.id,
      filename: file.filename,
      fileurl: file.fileurl,
      size: file.size,
      extension: file.extension,
      isNew: false
    }));

    this.attachments.current = [
      ...this.attachments.existing
    ];
  }

  /**
   * Adds an attachment to the current list of attachments after validating its type, size, and ensuring it doesn't exceed the maximum number of allowed attachments.
   * @param files The list of files to be added as attachments.
   */
  addAttachment(files: FileList): void {
    if (!files?.length) return;

    let currentTotalSize = this.attachments.current.reduce((total, file) => total + file.size, 0);

    let duplicateCount = 0;
    Array.from(files).forEach(file => {
      const extension = file.name.split('.').pop()?.toLowerCase() || '';
      if (!this.ATTACHMENT_TYPES.includes(extension)) {
        this.showToast(`${file.name} is not a supported file type`, 'error');
        return;
      }

      const duplicate = this.attachments.current.some(attachment => attachment.filename.toLowerCase() === file.name.toLowerCase());

      if (duplicate) {
        duplicateCount++;
        this.showToast(`${file.name} already exists`, 'error');
        return;
      }

      if (currentTotalSize + file.size > this.MAX_ATTACHMENT_SIZE) {
        this.showToast(`Maximum attachment size exceeded`, 'error');
        return;
      }

      const attachment: Attachment = {
        id: `temp_${this.tempIdCounter++}`,
        filename: file.name,
        fileurl: '',
        file,
        size: file.size,
        extension,
        isNew: true
      };

      this.attachments.current.push(
        attachment
      );

      this.attachments.new.push(
        attachment
      );

      currentTotalSize += file.size;
    });
    if (duplicateCount > 0) {
      this.showToast('Duplicate files skipped: ' + duplicateCount, 'error');
    }
    console.log('Current attachments:', this.attachments);
  }

  /**
   * Removes an attachment from the current list and adds it to the deleted list.
   * @param doc The attachment to be removed.
   */
  removeAttachment(attachment: Attachment): void {
    this.attachments.current = this.attachments.current.filter(file => file.id !== attachment.id);

    if (attachment.isNew) {
      this.attachments.new =
        this.attachments.new.filter(
          file => file.id !== attachment.id
        );
    } else {
      const alreadyDeleted = this.attachments.deleted.some(file => file.id === attachment.id);
      if (!alreadyDeleted) {
        this.attachments.deleted.push(attachment);
      }
    }
  }

  /**
   * Uploads the attachments to the server in bulk. Prepares the form data with campaign and stage details, as well as the list of new and deleted attachments.
   */
  bulkUploadFileOnServer(stageId): Observable<any> | void {
    stageId = stageId || this.stage.campaign_stage_id;

    const formData = new FormData();
    formData.append('campaign_id', this.campaign_details.campaign_id);
    formData.append('campaign_stage_id', stageId.toString());
    formData.append(
      'actions',
      JSON.stringify({
        attachments: {
          created: this.attachments.new.map(
            file => file.id
          ),
          deleted: this.attachments.deleted.map(
            file => file.id
          )
        }
      })
    );

    this.attachments.new.forEach(file => {
      if (file.file) {
        formData.append(
          file.id.toString(),
          file.file
        );
      }
    });
    if (!this.attachments.new.length && !this.attachments.deleted.length) {
      return;
    }
    this.uploadAttachmentInProgress = true;
    this.campaignService.uploadAttachments(formData).subscribe((response: any) => {
      if (response?.body?.success) {
        const resp = response.body;
        this.stage.attachments = resp.data;
        this.updateStageObject({
          ...this.stage,
        });
        this.resetAttachmentState(resp.data);
      }
      this.isEditMode.emit({
        stageId: stageId,
        editMode: false,
      });
      this.isInEditMode.editMode = false;
      this.uploadAttachmentInProgress = false;
    });
  }

  /**
   * Resets the attachment state by clearing the new and deleted lists and updating the existing list to match the current attachments.
   */
  resetAttachmentState(originalAttachments: any = this.stage.attachments || []): void {
    this.loadAttachments(originalAttachments);
    this.attachments.new = [];
    this.attachments.deleted = [];
  }

  /**
   * Displays a toast message with the specified type.
   * @param message The message to be displayed.
   * @param type The type of the message, either 'success' or 'error'. Defaults to 'success'.
   */
  showToast(message: string, type: 'success' | 'error' = 'success') {
    if (type == 'error') {
      this.errorMessage = message;
      setTimeout(() => (this.errorMessage = ""), 3000);
    } else {
      this.successMessage = message;
      setTimeout(() => (this.successMessage = ""), 3000);
    }
  }

  ngOnDestroy() {
    this.attachments = {
      current: [],
      new: [],
      deleted: [],
      existing: []
    };
  }
}
